import { NgModule } from '@angular/core';
import { IonCurrencyMaskModule } from '@pluritech/ion-currencymask';

import { MaxLengthDirective } from '../directives/max-length-directive';
import { DisableControlDirective } from './../directives/disable-control.directive';
import { MaskDirective } from './../directives/mask-directive';

@NgModule({
	declarations: [
		MaxLengthDirective,
		MaskDirective,
		DisableControlDirective
	],
	exports: [
		MaxLengthDirective,
		MaskDirective,
		IonCurrencyMaskModule,
		DisableControlDirective
	]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/shared.module.ts